import React from "react";

export default function HalotelAirTime() {
  return <div></div>;
}
